var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'company-logo-small': _vm.small }},[_c('div',{staticClass:"company-logo",class:`supplier-${_vm.id || 0}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }